module.exports = __webpack_public_path__ + "static/media/mobile-sms.df4e2dc1.svg";